import { Component, Input, OnInit } from '@angular/core';
import { ActiveWidget } from '../../classes/active-widget';
import { WidgetModel } from '../../models/widget.model';
import { LIST_PLUGIN_TYPE } from '../../../plugins/abstract-plugins/list/list-plugin-type';
import { LIST_PLUGIN_MODE } from '../../../plugins/abstract-plugins/list/list-plugin-mode';
import { ListWidgetOptions } from '../../interfaces/list-widget-options.interface';
import { dataGet } from '../../../support/helpers';

@Component({
    selector: 'chassis-core-list-widget',
    templateUrl: './list-widget.component.html',
    styleUrls: ['./list-widget.component.scss']
})
export class ListWidgetComponent implements OnInit {

    @Input() public widget: WidgetModel;

    /**
     * @type {ListWidgetOptions}
     */
    @Input() public options: ListWidgetOptions;

    /**
     * The collections of items.
     *
     * @type {Collection}
     */
    @Input() public items: Array<any>;

    /**
     * Plugin types enum to pass on to the template.
     *
     * @type {LIST_PLUGIN_TYPE}
     */
    public PLUGIN_TYPES = LIST_PLUGIN_TYPE;

    /**
     * Plugin modes enum to pass on to the template.
     *
     * @type {LIST_PLUGIN_MODE}
     */
    public PLUGIN_MODES = LIST_PLUGIN_MODE;

    @Input() public loader;

    constructor(public widgetRef: ActiveWidget) {
    }

    ngOnInit() {
        if (!this.options.mode) {
            this.options.mode = LIST_PLUGIN_MODE.TABLE;
        }
    }

    public refresh() {
        this.widgetRef.refresh();
    }

    public remove() {
        this.widgetRef.remove();
    }

    public get loading(): boolean {
        return this.loader
            ? this.loader.isLoading()
            : false;
    }

    public getData(value, property) {
        return dataGet(value ? value : {}, property);
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/dashboards/components/list-widget/list-widget.component.ts